import { gql } from '@apollo/client';

export const LEND_EVENTS_QUERY = gql`
  query ($pageNumber: Int!, $pageSize: Int, $filter: String) {
    events(
      name: [
        "PropertyExpensesEvent"
        "RentPaymentPaidEvent"
        "LateFeeEvent"
        "PublicDebtOrder"
      ]
      version: 1
      withPublic: true
      pageNumber: $pageNumber
      pageSize: $pageSize
      dataFilter: $filter
    ) {
      edges {
        node {
          id
          name
          data
          time
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;
